__turbopack_context__.v({
  "enter": "styles-module-scss-module__mWyhTq__enter",
  "exit": "styles-module-scss-module__mWyhTq__exit",
  "fade-in": "styles-module-scss-module__mWyhTq__fade-in",
  "fade-out": "styles-module-scss-module__mWyhTq__fade-out",
  "fade-out-80": "styles-module-scss-module__mWyhTq__fade-out-80",
  "hasValue": "styles-module-scss-module__mWyhTq__hasValue",
  "hiddenInput": "styles-module-scss-module__mWyhTq__hiddenInput",
  "placeholder": "styles-module-scss-module__mWyhTq__placeholder",
  "slide-in-from-bottom": "styles-module-scss-module__mWyhTq__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__mWyhTq__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__mWyhTq__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__mWyhTq__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__mWyhTq__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__mWyhTq__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__mWyhTq__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__mWyhTq__slide-out-to-top",
  "tag": "styles-module-scss-module__mWyhTq__tag",
  "tagLabel": "styles-module-scss-module__mWyhTq__tagLabel",
  "tagRemove": "styles-module-scss-module__mWyhTq__tagRemove",
  "tagsContainer": "styles-module-scss-module__mWyhTq__tagsContainer",
  "tagsWrapper": "styles-module-scss-module__mWyhTq__tagsWrapper",
  "zoom-in": "styles-module-scss-module__mWyhTq__zoom-in",
  "zoom-out": "styles-module-scss-module__mWyhTq__zoom-out",
});
